import { Injectable, inject } from '@angular/core';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { appsettings } from '../settings/appsettings';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor() { }

  private http = inject(HttpClient);
  private url = appsettings.apiUrl;

  listarRples(): Observable<any> {
    const url = `${this.url}/roles/getRole`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarMenu(): Observable<any> {
    const url = `${this.url}/roles/getMenu`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  actualizaRol(objeto: object):Observable<any>{
    const url = `${this.url}/roles/updateRole`; // URL completa en una variable para claridad
    return this.http.post<any>(url, objeto).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  insertarRol(objeto: object):Observable<any>{
    const url = `${this.url}/roles/insertRole`; // URL completa en una variable para claridad
    return this.http.post<any>(url, objeto).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

}
